import React from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Carusel from '../components/Carusel/Carusel';

export default function About() {
  return (
    <div id='galeria'>
      <Carusel />
    </div>
  );
}
